import { MY_APP_STATUS_PUBLISHED } from '../constants';
import type {
  SpotlightCatalogData,
  SpotlightHistoryData,
  SpotlightMyAppsData,
  SpotlightRecommendationData,
  SpotlightSearchData,
  SpotlightSearchParams,
} from '../types';
import { spotlightApi, ssoApi } from './client';

export const searchSpotlight = (params: SpotlightSearchParams, signal?: AbortSignal) =>
  spotlightApi.post<SpotlightSearchData, SpotlightSearchParams>('/api/v1/search', params, {
    signal,
  });

export const fetchSearchCatalog = (signal?: AbortSignal) =>
  spotlightApi.get<SpotlightCatalogData>('/api/v1/search/catalog', { signal });

export const fetchSearchHistory = (signal?: AbortSignal) =>
  spotlightApi.get<SpotlightHistoryData>('/api/v1/search/history?per_page=5', { signal });

export const fetchRecommendations = (signal?: AbortSignal) =>
  spotlightApi.get<SpotlightRecommendationData>('/api/v1/search/recommendations?per_page=3', {
    signal,
  });

/** App yang user punya akses: `status === published` (buang coming_soon + others). */
export const fetchMyApps = async (signal?: AbortSignal) => {
  const result = await ssoApi.get<SpotlightMyAppsData>('/api/v2/my-account/my-app', { signal });
  if (!result.data) return result;
  return {
    ...result,
    data: result.data.filter((app) => app.status === MY_APP_STATUS_PUBLISHED),
  };
};
